"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var CardRowTextEditor_1 = require("../../../../../../shared/components/editors/CardRowTextEditor");
var CardRowButtonSet_1 = require("../../../../../../shared/components/editors/CardRowButtonSet");
var notificationHelper_1 = require("../../../../../../shared/helpers/notificationHelper");
var CardEditorContainer_1 = require("../../../../../../shared/components/containers/CardEditorContainer");
var CardRowSelectEditor_1 = require("../../../../../../shared/components/editors/CardRowSelectEditor");
var CardRowTextAreaEditor_1 = require("../../../../../../shared/components/editors/CardRowTextAreaEditor");
var CardRowButtonTextEditor_1 = require("../../../../../../shared/components/editors/CardRowButtonTextEditor");
var CardRowDateEdit_1 = require("../../../../../../shared/components/editors/CardRowDateEdit");
var CardRowTimeEdit_1 = require("../../../../../../shared/components/editors/CardRowTimeEdit");
var CardRowCheckBoxEditor_1 = require("../../../../../../shared/components/editors/CardRowCheckBoxEditor");
var CmsPostRecordEditor = /** @class */ (function (_super) {
    __extends(CmsPostRecordEditor, _super);
    function CmsPostRecordEditor(props) {
        return _super.call(this, props) || this;
    }
    CmsPostRecordEditor.prototype.componentWillMount = function () {
        var _this = this;
        if (this.props.record) {
            this.setState({
                title: this.props.record.title,
                cms_image_url: this.props.record.cms_image_url,
                lang_id: this.props.record.app_language_id,
                lang_title: this.props.record.app_language_title,
                preview_text: this.props.record.preview_text,
                publish_year: this.props.record.post_year,
                publish_month: this.props.record.post_month,
                publish_day: this.props.record.post_day,
                publish_hour: this.props.record.post_hour,
                publish_minute: this.props.record.post_minute,
                publish_second: this.props.record.post_second,
                is_locked: this.props.record.is_locked
            }, function () {
                _this.props.state.setExtBreadCrumbPath(["Список публикаций", "Список записей", "Редактирование записи"]);
            });
        }
        else {
            this.setState({
                title: "",
                lang_id: -1,
                lang_title: "",
                preview_text: "",
                cms_image_url: "",
                publish_year: 2022,
                publish_month: 1,
                publish_day: 1,
                publish_hour: 0,
                publish_minute: 0,
                is_locked: false
            }, function () {
                _this.props.state.setExtBreadCrumbPath(["Список публикаций", "Список записей", "Создание записи"]);
            });
        }
        this.doReSetRules();
    };
    CmsPostRecordEditor.prototype.doReSetRules = function () {
        this.setState({
            title_rules: { isError: false },
            lang_rules: { isError: false },
            preview_text_rules: { isError: false },
            cms_image_url_rules: { isError: false }
        });
    };
    CmsPostRecordEditor.prototype.OnUpdateDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.EditData({
                title: this.state.title,
                app_language_id: this.state.lang_id,
                key: this.props.record.key,
                preview_text: this.state.preview_text,
                cms_image_url: this.state.cms_image_url,
                publish_year: this.state.publish_year,
                publish_month: this.state.publish_month,
                publish_day: this.state.publish_day,
                publish_hour: this.state.publish_hour,
                publish_minute: this.state.publish_minute,
                publish_second: this.state.publish_second,
                is_locked: this.state.is_locked,
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Запись изменена!");
            });
        }
    };
    CmsPostRecordEditor.prototype.isDataValid = function () {
        this.doReSetRules();
        if ((!this.state.title) || (this.state.title.length === 0)) {
            this.setState({ title_rules: { isError: true, errorMessage: "Поле [название] не заполнено!" } });
            return false;
        }
        if ((this.state.lang_id <= 0) || (this.state.lang_title.length === 0)) {
            this.setState({
                lang_rules: { isError: true, errorMessage: "Поле [язык] не выбрано!" }
            });
            return false;
        }
        if ((!this.state.preview_text) || (this.state.preview_text.length === 0)) {
            this.setState({ preview_text_rules: { isError: true, errorMessage: "Поле [Превью записи] не заполнено!" } });
            return false;
        }
        if ((!this.state.cms_image_url) || (this.state.cms_image_url.length === 0)) {
            this.setState({ cms_image_url_rules: { isError: true, errorMessage: "Поле [изображение] не выбрано!" } });
            return false;
        }
        return true;
    };
    CmsPostRecordEditor.prototype.OnNewDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.AddData({
                post_category_id: this.props.rootRecord.key,
                publish_year: this.state.publish_year,
                publish_month: this.state.publish_month,
                publish_day: this.state.publish_day,
                publish_hour: this.state.publish_hour,
                publish_minute: this.state.publish_minute,
                publish_second: this.state.publish_second,
                is_locked: this.state.is_locked,
                title: this.state.title,
                app_language_id: this.state.lang_id,
                cms_image_url: this.state.cms_image_url,
                preview_text: this.state.preview_text
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Запись добавлена!");
            });
        }
    };
    CmsPostRecordEditor.prototype.OnGoBackClick = function () {
        if (this.props.onGoBack) {
            this.props.onGoBack();
        }
    };
    CmsPostRecordEditor.prototype.getFormTitle = function () {
        if (!this.props.record) {
            return "Добавить запись";
        }
        else {
            return "Изменить запись";
        }
    };
    ////  private previewChanged(newVal: string) {
    //      this.setState({ preview_text: newVal })
    // }
    CmsPostRecordEditor.prototype.DoShowSelectImageDialog = function () {
        var _this = this;
        this.props.dialogSelectImage.SetDialogTitle("Выбор изображения").SetOnSelect(function (brandIdentity, dirName, fileName) {
            _this.setState({ cms_image_url: brandIdentity + "/" + dirName + "/" + fileName }, function () {
                _this.props.dialogSelectImage.Close();
            });
        }).Show();
    };
    CmsPostRecordEditor.prototype.render = function () {
        var _this = this;
        return (React.createElement(CardEditorContainer_1.default, { onGoBackClick: this.OnGoBackClick.bind(this), title: this.getFormTitle(), state: this.props.state, maxHeight: 700 },
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Заголовок:", placeholder: "Введите заголовок публикации" }, value: this.state.title, onValueChanged: function (newVal) {
                    _this.setState({
                        title: newVal,
                        title_rules: { isError: false }
                    });
                }, required: true, rules: this.state.title_rules }),
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Язык:", placeholder: "Выберите язык" }, value: { key: this.state.lang_id, value: this.state.lang_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        lang_id: newVal.key,
                        lang_title: newVal.value,
                        lang_rules: { isError: false },
                    });
                }, items: this.props.languagesList, disabled: this.props.record != null, required: true, rules: this.state.lang_rules }),
            React.createElement(CardRowDateEdit_1.default, { texts: { caption: "Дата публикации", placeholder: "Выберите дату" }, value: {
                    day: this.state.publish_day,
                    month: this.state.publish_month,
                    year: this.state.publish_year
                }, onValueChanged: function (year, month, day) {
                    _this.setState({
                        publish_day: day,
                        publish_month: month,
                        publish_year: year
                    });
                } }),
            React.createElement(CardRowTimeEdit_1.default, { texts: { caption: "Время публикации", placeholder: "Выберите время" }, value: {
                    hour: this.state.publish_hour,
                    minute: this.state.publish_minute,
                    second: this.state.publish_second
                }, onValueChanged: function (hour, minute, second) {
                    _this.setState({
                        publish_hour: hour,
                        publish_minute: minute,
                        publish_second: second
                    });
                } }),
            React.createElement(CardRowButtonTextEditor_1.default, { texts: {
                    caption: "Изображение:",
                    placeholder: "Выберите изображение",
                    buttonHint: "Выберите изображение"
                }, readonly: true, onButtonClick: this.DoShowSelectImageDialog.bind(this), onValueChanged: function (newVal) {
                    _this.setState({
                        cms_image_url: newVal,
                        cms_image_url_rules: { isError: false }
                    });
                }, value: this.state.cms_image_url, buttonIcon: "search", required: true, rules: this.state.cms_image_url_rules }),
            React.createElement(CardRowTextAreaEditor_1.default, { texts: { caption: "Превью записи:", placeholder: "Введите текст превью записи" }, value: this.state.preview_text, onValueChanged: function (newVal) {
                    _this.setState({ preview_text: newVal });
                }, rowsCount: 8, required: true, rules: this.state.preview_text_rules }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Публикация заблокирована", value: this.state.is_locked, onChecked: function (checked) { _this.setState({ is_locked: checked }); } }),
            React.createElement(CardRowButtonSet_1.default, { editMode: this.props.record != null, title: { btnEdit: "Сохранить", btnNew: "Создать", btnGoBack: "Вернуться" }, onGoBackClick: this.OnGoBackClick.bind(this), onAddClick: this.OnNewDataClick.bind(this), onEditClick: this.OnUpdateDataClick.bind(this) })));
    };
    return CmsPostRecordEditor;
}(React.Component));
exports.default = CmsPostRecordEditor;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/cms_posts/ui/component/CmsPostRecordEditor.tsx
// module id = 2381
// module chunks = 0